/* eslint-disable no-unused-vars */
import { Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { FcMoneyTransfer } from "react-icons/fc";
import FundTreasuryModal from "../../../../components/modals/FundTreasuryModal";

const Body = ({ list, currency, users, isLoading, domainBrand }) => {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  // const dispatch = useDispatch();
  const { Column } = Table;
  // const menuPortalTarget = document.getElementById("root");
  const [show, setShow] = useState(false);
  const [actionType, setActionType] = useState("");
  const [accDetails, setAccountDetails] = useState({
    accountId: "",
    accountBalance: "",
    selectedBeneficiary: "",
    customerWalletAccounts: "",
  });
  const [accountId, setAccountId] = useState("");
  const [accountBalance, setAccountBal] = useState(0);

  // const [filterInput] = useState("");
  // const [accountType, setAccountType] = useState({});
  // const [money, setMoney] = useState({});

  const tableData =
    list &&
    list?.map((i, index) => {
      return { ...i, key: index + 1 };
    });

  return (
    <>
      <FundTreasuryModal
        currency={currency}
        dictionary={dictionary}
        show={show}
        handleClose={() => {
          setShow(false);
        }}
        actionType={actionType}
        accountId={accountId}
        accountBalance={accountBalance}
        accDetails={{ ...accDetails }}
      />
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">Treasury Accounts</h1>
            </div>
            <div className="ms-auto pageheader-btn" />
          </div>

          <div className="row row-sm">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title">All Treasury Accounts</h3>
                </div>
                <div className="card-body">
                  <div>
                    {/* <p className="text-muted card-sub-title">
                    Filter account to fetch the account lists
                  </p> */}
                  </div>
                  <div className="table-responsive">
                    {/* <div className="form-row mb-5 pb-5">
                    <div className="col-md-6 col-lg-6">
                      <label>Account Type</label>
                      <Select
                        options={treasuryAccountTypes}
                        isClearable={false}
                        isSearchable={true}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        value={accountType}
                        onChange={(option) => setAccountType(option)}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <label>
                        Currency
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Select
                        options={currency}
                        isClearable={false}
                        isSearchable={false}
                        maxMenuHeight={250}
                        menuPlacement="bottom"
                        menuPortalTarget={menuPortalTarget}
                        name="currency"
                        value={money}
                        onChange={(option) => setMoney(option)}
                      />
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary margin-label w-100"
                        type="button"
                        onClick={() => fetchTreasury(payload)}
                      >
                        Search{" "}
                        {treasuries.loadingTreasuries === Loading.FETCHING && (
                          <>
                            &nbsp;
                            <i className="fa fa-spinner fa-spin" />
                          </>
                        )}
                      </button>
                    </div>

                    <div className="col-md-6 col-lg-6">
                      <button
                        className="btn btn-primary margin-label w-100"
                        type="button"
                      >
                        Print/Download PDF
                      </button>
                    </div>
                  </div> */}
                    <Table
                      dataSource={tableData}
                      className="w-100 table tbody"
                      loading={isLoading}
                      pagination
                    >
                      <Column
                        title="Date"
                        dataIndex="creationDate"
                        key="1"
                        className=""
                        render={(text) => {
                          return (
                            <span className="text-lowercase whitespace">
                              {moment(text).format("DD/MM/YYYY")}
                            </span>
                          );
                        }}
                        sorter={(a, b) => a.creationDate - b.creationDate}
                      />
                      <Column
                        title="Account Holder Name"
                        dataIndex="accountHolderName"
                        key="2"
                        className=""
                        width={300}
                      />
                      <Column
                        title="Find Beneficiary by Account Number"
                        dataIndex="phoneIdWalletAccountNumber"
                        key="3"
                        className=""
                        width={500}
                      />
                      <Column
                        title="Account Type"
                        dataIndex="walletAccountType"
                        key="4"
                        className=""
                        width={100}
                      />
                      <Column
                        title="Balance"
                        dataIndex="accountBalance"
                        key="5"
                        className=""
                      />
                      <Column
                        title="Action"
                        dataIndex="createdDate"
                        key="6"
                        className=""
                        render={(text, record) => {
                          return (
                            <Space size={"middle"}>
                              {/* <Tooltip
                                title={"Withdraw from account"}
                                color="#212529"
                                placement="bottom"
                                arrowPointAtCenter={true}
                              >
                                <MdPayment
                                  fontSize={25}
                                  color={"#6259CA"}
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setShow(true);
                                    setActionType("DEFUND");
                                    setAccountId(record.accountId);
                                    setAccountDetails({
                                      accountId: record.accountId,
                                      accountBalance: record.accountBalance,
                                      selectedBeneficiary: "",
                                      customerWalletAccounts:
                                        record?.phoneIdWalletAccountNumber,
                                    });
                                  }}
                                />
                              </Tooltip> */}
                              <Tooltip
                                title={"Fund account"}
                                color="#212529"
                                placement="bottom"
                                arrowPointAtCenter={true}
                              >
                                <FcMoneyTransfer
                                  fontSize={25}
                                  color={"#6259CA"}
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setShow(true);
                                    setActionType("FUND");
                                    setAccountId(record.accountId);
                                    setAccountBal(record.accountBalance);
                                    setAccountDetails({
                                      accountId: record.accountId,
                                      accountBalance: record.accountBalance,
                                      selectedBeneficiary: "",
                                      customerWalletAccounts:
                                        record?.phoneIdWalletAccountNumber,
                                      currencyCode: record?.currencyCode,
                                    });
                                  }}
                                />
                              </Tooltip>
                            </Space>
                          );
                        }}
                      />
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Body;
